import { Transition, Message } from 'semantic-ui-react';

import * as Styles from './error-message.module.less';

export interface ErrorMessageInterface {
    error: string;
    header?: string;
    onDismiss?: () => void;
}

export const ErrorMessage = (props: ErrorMessageInterface) => (
    <Transition transitionOnMount animation="fade right">
        <Message negative className={Styles.errorMessage} onDismiss={props.onDismiss}>
            {props.header && <Message.Header as="p">{props.header}</Message.Header>}
            <p>{props.error}</p>
        </Message>
    </Transition>
);
